export default __webpack_public_path__ + "115e8a64284b32411d5d4198e0e24524.svg";